<!--
 * @Description: 用户配置页面
 * @Author: gaohc, fengal
 * @Date: 2022-11-02 16:43:52
-->
<template>
  <div class="body">
    <div class="div-header">
      <div class="back-tabs">
        <span class="tab-item mouse-pointer" @click="handleClickTabItem(index)" 
          v-for="(item, index) in tabList" :key="index" :class="{active: index == currentTabItem}">
          {{item.text}}
        </span>
      </div>
    </div>
    <div class="main-line"></div>
    <div class="back-card">
      <resident-usercfg-main v-if="currentTabItem == 0" :listUsership="usershipList" 
        @add-usership="handleUsershipAdd" @edit-usership="handleUsershipEdit" @delete-usership="handleUsershipDelete" />
      <el-row :gutter="45" v-if="currentTabItem == 1">
        <el-col :span="8">
          <attendant-cfg-main title="培训证书类型" :attendantList="trainingCertTypeList" @add-attendant="handleTrainingCertTypeAdd"
            @edit-attendant="handleAttendantEdit" @delete-attendant="handleTrainingCertTypeDelete" />
        </el-col>
        <el-col :span="8">
          <attendant-cfg-main title="评价标签" :attendantList="commentLabelList" @add-attendant="handleCommentLabelAdd"
            @edit-attendant="handleAttendantEdit" @delete-attendant="handleCommentLabelDelete" />
        </el-col>
      </el-row>
    </div>
    <usership-dialog :visible="showUsershipDialog" :operate="dialogOperate" :usershipId="usershipId"
      @close-dialog="closeUsershipDialog" />
    <attendant-dialog :title="dialogTitle" :visible="showAttendantDialog" :operate="dialogOperate" 
      :attendantDialogId="attendantDialogId"
      @close-attendant-dialog="closeAttendantDialog">
    </attendant-dialog>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import ResidentCfg from './components/usercfg/ResidentCfg.vue'
import AttendantCfg from './components/usercfg/AttendantCfg.vue'
import UsershipDialog from './components/usercfg/UsershipDialog.vue'
import AttendantCfgDialog from './components/usercfg/AttendantCfgDialog.vue'

export default {
  name: 'UserCfg',
  components: {
    'resident-usercfg-main': ResidentCfg,
    'attendant-cfg-main': AttendantCfg,
    'usership-dialog': UsershipDialog,
    'attendant-dialog': AttendantCfgDialog,
  },

  data() {
    return {
      dataPvgList: [],    //在角色配置页面上的操作权限
      tabList: [{text: '居民用户配置'}, {text: '护工用户配置'}],
      currentTabItem: 0,
      dialogOperate: 'add',
      
      // 以下变量用于用户关系对话框组件调用
      showUsershipDialog: false,
      usershipId: '',
      usershipList: [],
      
      //以下变量用于护工配置对话框组件调用
      showAttendantDialog: false,
      attendantDialogId: '',
      dialogTitle: '',

      //以下变量用于护工配置组件调用
      trainingCertTypeList: [],  
      commentLabelList: [],
    }
  },

  methods: {
    //初始化用户关系数据
    async initUsershipData() {
      await this.getDataPvg4CurRole();
      await this.appAxios('GET', Constant.URL_LIST_USERSHIPCFG).then((result) => {
        if (result != null) {
          this.usershipList = result.data || [];
        }
      })
    },

    getDataPvg4CurRole() {
      return new Promise((resolve) => {
        let requestData = {
          method: 'GET',
          url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
          param: {entityKey: 'DICT'},
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataPvgList = result.data;
            resolve();
          }
        })
      })
    },

    // 初始化评价标签数据
    initCommentLabelData() {
      this.appAxios('GET', Constant.URL_LIST_COMMENTLABELCFGS).then((result) => {
        if (result != null) {
          this.commentLabelList = result.data || [];
        }
      })
    },

    // 初始化培训证书类型数据
    initTrainingCertTypeData() {
      this.appAxios('GET', Constant.URL_LIST_TRAININGCERTCFGS).then((result) => {
        if (result != null) {
          this.trainingCertTypeList = result.data || [];
        }
      })
    },

    // 对话框组件公用方法
    initAttendantDialogParam(showAttendantDialog, dialogOperate, attendantDialogId, title) {
      this.showAttendantDialog = showAttendantDialog;
      this.dialogOperate = dialogOperate;
      this.attendantDialogId = attendantDialogId;
      this.dialogTitle = title;
    },

    // tab栏点击切换事件
    handleClickTabItem(index) {
      this.currentTabItem = index;
      if (index == 1) {
        this.initCommentLabelData();
        this.initTrainingCertTypeData();
      }
    },

    //以下方法用于用户关系相应组件调用
    handleUsershipAdd() {
      if (!this.dataPvgList.includes('DICT_1_CREATE')) {
        this.$message.error( "无新增权限");
        return;
      }
      if (!this.limitAddCount(this.usershipList)) return
      this.showUsershipDialog = true;
      this.dialogOperate = 'add';
      this.usershipId = '';
    },

    handleUsershipEdit(usership) {
      if (!this.dataPvgList.includes('DICT_2_UPDATE')) {
        this.$message.error( "无编辑权限");
        return;
      }
      this.showUsershipDialog = true;
      this.dialogOperate = 'edit';
      this.usershipId = usership.id;
    },

    closeUsershipDialog(refresh) {
      this.showUsershipDialog = false;
      if (refresh) this.initUsershipData();
    },

    handleUsershipDelete(usership) {
      if (!this.dataPvgList.includes('DICT_3_DELETE')) {
        this.$message.error( "无删除权限");
        return;
      }
      this.$confirm('用户关系 ' + usership.name + ' 将被删除，是否继续删除？', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning',
      }).then(() => {
        this.deleteUserCfg(usership.id)
      })
    },

    deleteUserCfg(id) {
      let params = {id: id};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'DELETE',
        url: Constant.URL_DELETE_USERSHIPCFG,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then((result) => {
        if(result == null) {
          return;
        }
        this.initUsershipData();
      });
    },
    
    //以下方法用于培训证书类型、评价标签公用
    handleAttendantEdit(title, row) {
      if (!this.dataPvgList.includes('DICT_2_UPDATE')) {
        this.$message.error( "无编辑权限");
        return;
      }
      this.initAttendantDialogParam(true, 'edit', row.id, title);
    },

    //以下方法用于培训证书类型相应组件调用
    handleTrainingCertTypeAdd(title) {
      if (!this.dataPvgList.includes('DICT_1_CREATE')) {
        this.$message.error( "无新增权限");
        return;
      }
      if (!this.limitAddCount(this.trainingCertTypeList)) return
      this.initAttendantDialogParam(true, 'add', '', title);
    },

    handleTrainingCertTypeDelete(attendant) {
      if (!this.dataPvgList.includes('DICT_3_DELETE')) {
        this.$message.error( "无删除权限");
        return;
      }
      this.$confirm('培训证书类型 ' + attendant.certText + ' 将被删除，是否继续删除？', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning',
      }).then(() => {
        this.deleteAttendantCertCfg(attendant.id);
      })
    },

    deleteAttendantCertCfg(id) {
      let params = {id: id};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'DELETE',
        url: Constant.URL_DELETE_TRAININGCERTCFG,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then((result) => {
        if(result == null) {
          return;
        }
        this.initTrainingCertTypeData();
      });
    },

    //以下方法用于评价标签相应组件调用
    handleCommentLabelAdd(title) {
      if (!this.dataPvgList.includes('DICT_1_CREATE')) {
        this.$message.error( "无新增权限");
        return;
      }
      if (!this.limitAddCount(this.commentLabelList)) return
      this.initAttendantDialogParam(true, 'add', '', title);
    },

    closeAttendantDialog(title, refresh) {
      this.showAttendantDialog = false;
      if (refresh && title == '培训证书类型') this.initTrainingCertTypeData();
      if (refresh && title == '评价标签') this.initCommentLabelData();
    },

    handleCommentLabelDelete(attendant) {
      if (!this.dataPvgList.includes('DICT_3_DELETE')) {
        this.$message.error( "无删除权限");
        return;
      }
      this.$confirm('评价标签 ' + attendant.labelText + ' 将被删除，是否继续删除？', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning',
      }).then(() => {
        this.deletecommentCfg(attendant.id);
      })
    },
    
    deletecommentCfg(id) {
      let params = {id: id};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'DELETE',
        url: Constant.URL_DELETE_COMMENTLABELCFG,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then((result) => {
        if(result == null) {
          return;
        }
        this.initCommentLabelData();
      });
    },

    //控制最多配置数量
    limitAddCount(arrList) {
      if (arrList.length < 20) return true;

      this.$message({showClose: true, message: '最多配置20条', type: 'error'});
      return false
    },
  },

  mounted() {
    this.$emit('breadcrumb', {text1: '系统配置', text2: '用户配置'});
    this.initUsershipData();
  },
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.div-header {
  text-align: left;
  margin-left: 22px;
}

.back-tabs {
  display: flex;
  flex-direction: row;
}

.tab-item {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3e7ef5;
  background-color: white;
  font-size: 14px;
  width: 140px;
  height: 28px;
  border-radius: 14px;
}

.active {
  color: white;
  background-color: #3e7ef5;
}

.main-line {
  margin-top: 10px;
  height: 10px;
  background-color: #f0f0f0;
}

.back-card {
  margin-top: 15px;
  margin-left: 22px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/syscfg/UserCfg.vue